import { render } from "./Html.vue?vue&type=template&id=8671fb88&scoped=true"
import script from "./Html.vue?vue&type=script&lang=js"
export * from "./Html.vue?vue&type=script&lang=js"

import "./Html.vue?vue&type=style&index=0&id=8671fb88&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8671fb88"]])

export default __exports__